import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild, Output, ChangeDetectionStrategy } from '@angular/core';
import { Customerlogo } from './model/customerlogo';
import { CustomerlogoService } from './service/customerlogo.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '@src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { animate, style, transition, trigger } from "@angular/animations";

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerlogo',
  templateUrl: './customerlogo.component.html',
  styleUrls: ['./customerlogo.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0, position: "absolute" }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 0, position: "absolute" }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class CustomerlogoComponent implements OnInit, OnChanges {
  showSpinner: boolean;
  @Input() enableChange: boolean;
  showFileDialog: boolean;
  selectedFiles: FileList;
  @Output() loading: boolean;
  selectedFileName: string;
  customerLogo: Customerlogo;
  logosize: string;
  @Input() customerlistmode: boolean = false;
  @Input() customerId: string;
  imgurl: SafeUrl;
  updating: boolean;
  @ViewChild('closeclmodal', { static: true }) closeclmodal: ElementRef;
  private customerlogoService = inject(CustomerlogoService);
  private sanitizer = inject(DomSanitizer);
  private cdr = inject(ChangeDetectorRef);
  private logoVersion = 0;
  constructor(
    private http: HttpClient,
    private uiEventHub: UieventhubService,
  ) { }

  private getCustomerBaseId(): string {
    const normalizedCustomerId = String(this.customerId || '').trim();
    return normalizedCustomerId ? normalizedCustomerId.split('_')[0] : '';
  }

  private setLogoUrl(): void {
    // Customer logos have a fixed key per org + customer (minted by the backend
    // as pub/org/<orgId>/customer/<customerId>/logo.webp).
    const customerBaseId = this.getCustomerBaseId();
    const orgId = SessionHelper.getChoosenOrg();
    const logoUrl = customerBaseId && orgId
      ? `${environment.logostore}pub/org/${orgId}/customer/${customerBaseId}/logo.webp`
      : `${environment.logostore}org_blank.png`;

    this.imgurl = this.sanitizer.bypassSecurityTrustUrl(this.withVersion(logoUrl));
  }

  private withVersion(url: string): string {
    return this.logoVersion ? `${url}?v=${this.logoVersion}` : url;
  }

  ngOnInit() {
    this.updating = false;
    this.setLogoUrl();
  }

  changeLogo() {
    if (this.enableChange) {
      this.showFileDialog = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setLogoUrl();
  }

  onDocumentSubmit() {
    const customerBaseId = this.getCustomerBaseId();
    if (!customerBaseId || !this.croppedImage) {
      this.showSpinner = false;
      this.updating = false;
      return;
    }

    this.showSpinner = true;
    this.updating = true;
    this.customerLogo = new Customerlogo();

    var filename = 'logo.webp';
    var file = this.base64ToFile(this.croppedImage, filename);

    this.customerlogoService.getSignedUploadUrl(filename, SessionHelper.getChoosenOrg(), customerBaseId).pipe(untilDestroyed(this)).subscribe(SignedUploadUrl => {
      this.customerlogoService.addCustomerLogoFile(file, SignedUploadUrl.url).pipe(untilDestroyed(this)).subscribe(resp => {
        //re-load image
        this.imgurl = this.sanitizer.bypassSecurityTrustUrl(SignedUploadUrl.objectUrl);
        this.updating = false;
        this.showFileDialog = false;
        this.showSpinner = false;
      });
    })
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles.item(0).name;
  }

  closefileUpload() {
    this.showFileDialog = false;
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperready: boolean;

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.selectedFiles = event.target.files;
    this.selectedFileName = this.selectedFiles.item(0).name;
  }
  imageCropped(event: ImageCroppedEvent) {
    //console.log(event);
    this.croppedImage = event.base64;
  }
  cropperReady() {
    // cropper ready
    this.cropperready = true;
  }
  loadImageFailed() {
    // show message
  }
  base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
}
